import { render, staticRenderFns } from "./QuickCategoryCreate.vue?vue&type=template&id=d9b5ab90&scoped=true"
import script from "./QuickCategoryCreate.vue?vue&type=script&lang=js"
export * from "./QuickCategoryCreate.vue?vue&type=script&lang=js"
import style0 from "./QuickCategoryCreate.vue?vue&type=style&index=0&id=d9b5ab90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b5ab90",
  null
  
)

export default component.exports